import React, { useState, useEffect, useReducer, FC } from 'react';

// CSS
import styles from '@UILayer/UILayer.scss';

const WinlineItem: React.FC<{ index: number; pos: Array<number>; type: number; rowNo: number }> = (data) => {
    const [state, setState] = useReducer((state: { winline: Array<number> }, newState: any) => ({ ...state, ...newState }), { winline: [] });

    const viewBoxSize: { [key: string]: string } = {
        '3x3': '0 0 199 176.5',
        '3x5': '0 0 199 180',
        '3x6': '0 0 235 180',
        '4x5': '0 0 199 230',
        '4x6': '0 0 235 230'
    };

    const bgBoxSize: { [key: string]: { w: number; h: number } } = {
        '3x3': { w: 199, h: 149 },
        '3x5': { w: 199, h: 149 },
        '3x6': { w: 235, h: 149 },
        '4x5': { w: 199, h: 190 },
        '4x6': { w: 235, h: 190 }
    };

    const positionData: { [key: number]: any } = {
        3: {
            0: {
                1: { cx: 63, cy: 31 },
                2: { cx: 63, cy: 75 },
                3: { cx: 63, cy: 119 },
                4: { cx: 63, cy: 163 }
            },
            1: {
                1: { cx: 100, cy: 31 },
                2: { cx: 100, cy: 75 },
                3: { cx: 100, cy: 119 },
                4: { cx: 100, cy: 163 }
            },
            2: {
                1: { cx: 137, cy: 31 },
                2: { cx: 137, cy: 75 },
                3: { cx: 137, cy: 119 },
                4: { cx: 137, cy: 163 }
            }
        },
        5: {
            0: {
                1: { cx: 26, cy: 31 },
                2: { cx: 26, cy: 75 },
                3: { cx: 26, cy: 119 },
                4: { cx: 26, cy: 163 }
            },
            1: {
                1: { cx: 63, cy: 31 },
                2: { cx: 63, cy: 75 },
                3: { cx: 63, cy: 119 },
                4: { cx: 63, cy: 163 }
            },
            2: {
                1: { cx: 100, cy: 31 },
                2: { cx: 100, cy: 75 },
                3: { cx: 100, cy: 119 },
                4: { cx: 100, cy: 163 }
            },
            3: {
                1: { cx: 137, cy: 31 },
                2: { cx: 137, cy: 75 },
                3: { cx: 137, cy: 119 },
                4: { cx: 137, cy: 163 }
            },
            4: {
                1: { cx: 174, cy: 31 },
                2: { cx: 174, cy: 75 },
                3: { cx: 174, cy: 119 },
                4: { cx: 174, cy: 163 }
            }
        },
        6: {
            0: {
                1: { cx: 26, cy: 31 },
                2: { cx: 26, cy: 75 },
                3: { cx: 26, cy: 119 },
                4: { cx: 26, cy: 163 }
            },
            1: {
                1: { cx: 63, cy: 31 },
                2: { cx: 63, cy: 75 },
                3: { cx: 63, cy: 119 },
                4: { cx: 63, cy: 163 }
            },
            2: {
                1: { cx: 100, cy: 31 },
                2: { cx: 100, cy: 75 },
                3: { cx: 100, cy: 119 },
                4: { cx: 100, cy: 163 }
            },
            3: {
                1: { cx: 137, cy: 31 },
                2: { cx: 137, cy: 75 },
                3: { cx: 137, cy: 119 },
                4: { cx: 137, cy: 163 }
            },
            4: {
                1: { cx: 174, cy: 31 },
                2: { cx: 174, cy: 75 },
                3: { cx: 174, cy: 119 },
                4: { cx: 174, cy: 163 }
            },
            5: {
                1: { cx: 211, cy: 31 },
                2: { cx: 211, cy: 75 },
                3: { cx: 211, cy: 119 },
                4: { cx: 211, cy: 163 }
            }
        }
    };

    useEffect(() => {
        setState({ winline: data.pos });
    }, []);

    function style(row: number, pos: number) {
        return `${state.winline[row] === pos ? styles.active_dot : styles.normal_dot}`;
    }

    function returnGroup() {
        let rows = [];

        for (var i = 0; i < data.type; i++) {
            const posData = positionData[data.type];

            rows.push(
                <g key={i} id={`_${i}`} data-name={i}>
                    <g>
                        <circle className={style(i, 1)} cx={posData[i][1].cx} cy={posData[i][1].cy} r="12.5" />
                        <circle className={style(i, 2)} cx={posData[i][2].cx} cy={posData[i][2].cy} r="12.5" />
                        <circle className={style(i, 3)} cx={posData[i][3].cx} cy={posData[i][3].cy} r="12.5" />

                        {data.rowNo === 4 && <circle className={style(i, 4)} cx={posData[i][4].cx} cy={posData[i][4].cy} r="12.5" />}
                    </g>
                </g>
            );
        }

        return <g id="rows_group">{rows}</g>;
    }

    return (
        <>
            {state.winline.length > 0 && (
                <>
                    <svg id={`winline_index_${data.index}`} viewBox={viewBoxSize[`${data.rowNo}x${data.type}`]}>
                        <g id="bg">
                            <rect
                                className={styles.winline_rect_bg}
                                width={bgBoxSize[`${data.rowNo}x${data.type}`].w}
                                height={bgBoxSize[`${data.rowNo}x${data.type}`].h}
                                rx="12"
                                ry="12"
                            />
                        </g>

                        {returnGroup()}

                        <g id="counter">
                            <g>
                                <circle className={styles.winline_counter_bg} cx="99.5" cy="157" r="19.5" />
                                <text className={styles.winline_counter_font} x="50%" y="95%" dominantBaseline="middle" textAnchor="middle">
                                    {data.index + 1}
                                </text>
                            </g>
                        </g>
                    </svg>
                </>
            )}
        </>
    );
};

export default WinlineItem;
